
      if (!window.__PILA_AUTH_REDIRECT) {
        import('/src/main.js')
      }
    